/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCriticalPointDetailItemDto } from './GetCriticalPointDetailItemDto';
import {
    GetCriticalPointDetailItemDtoFromJSON,
    GetCriticalPointDetailItemDtoFromJSONTyped,
    GetCriticalPointDetailItemDtoToJSON,
} from './GetCriticalPointDetailItemDto';

/**
 * 
 * @export
 * @interface GetCriticalPointDetailsDto
 */
export interface GetCriticalPointDetailsDto {
    /**
     * 
     * @type {Array<GetCriticalPointDetailItemDto>}
     * @memberof GetCriticalPointDetailsDto
     */
    items: Array<GetCriticalPointDetailItemDto>;
}

/**
 * Check if a given object implements the GetCriticalPointDetailsDto interface.
 */
export function instanceOfGetCriticalPointDetailsDto(value: object): value is GetCriticalPointDetailsDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetCriticalPointDetailsDtoFromJSON(json: any): GetCriticalPointDetailsDto {
    return GetCriticalPointDetailsDtoFromJSONTyped(json, false);
}

export function GetCriticalPointDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCriticalPointDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetCriticalPointDetailItemDtoFromJSON)),
    };
}

export function GetCriticalPointDetailsDtoToJSON(value?: GetCriticalPointDetailsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(GetCriticalPointDetailItemDtoToJSON)),
    };
}

